import React, { useEffect } from 'react'
import { InvestmentHeader, LeftSection, InvestmentColTwoSpan,BodyText, InvestmentColTwoSpanReverse, RightSection, InvestmentWrapper, NavLink, TextBox, RightColSection, LeftColSection } from './Investment.styles'

export const Investment = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <InvestmentWrapper>
      <InvestmentHeader>
        <LeftSection>
          <h3>
                    Investments made simple and worth it, to match your 
                    financial standing and help you gradually build a fortune
          </h3>
          <NavLink to = "/">
              Start Investing
          </NavLink>
        </LeftSection>
        <RightSection>
            <img src="img/amico.jpg" alt="" />
        </RightSection>
      </InvestmentHeader>
      <BodyText>
          <p> If you have been able to cultivate a savings discipline, 
            then you need to even make more better financial decisions 
            like investing to further build your wealth and achieve true 
            financial freedom. You get to choose what investment opportunity 
            you want, as you invest on your own terms</p>
      </BodyText>

      
      <InvestmentColTwoSpanReverse>
        <LeftColSection>
          <h3>Mini Investment</h3>
          <BodyText>
                    The process of building a solid investment portfolio can 
                    begin with some few thousands of naira, it does not have 
                    to always be the big amount, investing even small amounts
                    can reap big rewards on the long run of accruing investments
                    Once you have a little money to play with either from your 
                    target savings or salary or wages etc. you definitely can start
                    to invest, this investment plan has been carefully structured to
                    help you accrue good returns from it’s investment opportunities
                    over a period of time into a larger profit with which you can 
                    use to start another investment on more profitable investment
                    listings on our next stage of investment plan or you can as well withdraw.
                    Our mini investment are smartly and mostly on agricultural products 
                    insured against loss by reputable insurance and asset management 
                    companies in Nigeria.

          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/Frame.jpg" alt="" />
        </RightColSection>
      </InvestmentColTwoSpanReverse>
      <InvestmentColTwoSpan>
        <LeftColSection>
          <h3>Cardinal Investment</h3>
          <BodyText>
                This investment plan is geared towards a gradual buildup of your wealth,
                on this plan, you can either make investments alone or co-invest
                 with another Bonpellz user or a third party and the returns will be 
                 shared according to the proportion with which the investment was made, 
                 this plan serves as the intermediary between the mini investment and
                  foreign investment plan.
                This plan brings about a larger profit orchestrated by the kind of bigger 
                investment listings on it which comes with their maximum protection against
                 loss as they are managed by professionals.


          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/amico1.jpg" alt="" />
        </RightColSection>
      </InvestmentColTwoSpan>
      <InvestmentColTwoSpanReverse>
        <LeftColSection>
          <h3>Foreign Investment</h3>
          <BodyText>
                    This investment plan involves the flow of cash from our
                    customers to another country in form of an investment which 
                    allows them a vast ownership stakes in domestics companies and
                    also the assets of the foreign countries.
                    This plan allows our customers to obtain higher return than 
                    would be achievable on comparable domestic investment back at
                    home, hence aids a larger cash flow back into the country. 
                    it is intended and properly structured to build you a fortune 
                    as they are protected against loss and managed by our partners 
                    duly registered with the security and exchanged commission

          </BodyText>
        </LeftColSection>
        <RightColSection>
            <img src="img/Group 8622.svg" alt="" />
        </RightColSection>
      </InvestmentColTwoSpanReverse>
    
    </InvestmentWrapper>
  )
}
